<template>
  <div class="week-schedule">
    <div class="schedule-top">
      <div class="class-name">
        {{classInfor.className}}
      </div>
      <div class="week-operation">
        <div @click="pre">
          <van-icon name="arrow-left" size="0.2rem" color="#FB5252" />
          <span class="pre">上一周</span>
        </div>
        <div class="operation-date">{{ weekStart }} 至 {{ weekEnd }}</div>
        <div @click="next">
          <span class="next">下一周</span>
          <van-icon name="arrow" size="0.2rem" color="#FB5252" />
        </div>
      </div>
    </div>
    <div v-if="list.length > 0" class="list">
      <div v-for="(item, index) in list" :key="index" class="list-content">
        <div class="list-title">{{item.date}}</div>
        <div class="list-item" v-for="(inneritem, innerIndex) in item.items" :key="innerIndex">
          <div class="list-item-top">
            <div class="list-item-title">
              <div class="list-item-title-text">
                {{ inneritem.courseName }}
              </div>
            </div>
          </div>
          <div class="list-item-bottom">
            <div class="bottom-content">
              <div class="content">
                <div class="label">授课老师</div>
                <div class="value"> {{inneritem.teacher ? inneritem.teacher : "暂无"}} </div>
              </div>
              <div class="content">
                <div class="label">上课时间</div>
                <div class="value"> {{inneritem.beginTime}} - {{inneritem.endTime}} </div>
              </div>
            </div>
            <div class="bottom-content margintop-content">
              <div class="content">
                <div class="label">上课地点</div>
                <div class="value">{{inneritem.place ? inneritem.place : "暂无"}}</div>
              </div>
            </div>
          </div>
          <div class="line-grey" v-show="innerIndex != ( item.items.length - 1)"></div>
        </div>
      </div>
    </div>
    <div v-else class="arrange-nodata">
      <div class="nodatacontent">
        <img
          :src="require('_teas/public/img/product/bootScreen/img-null.png')"
          alt=""
          srcset=""
        />
        <div class="text">暂无课程</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      weekStart: "",
      weekEnd: "",
      list: []
    };
  },
  props: {
    classInfor: {
      type: Object,
      default() {
        return {}
      }
    },
    classId: {
        type : String,
        default: ''
    }
  },
  watch: {
   classId: function() {
     this.initWeek();
   }
  },
  mounted() {
    this.initWeek();
  },
  methods: {
    initWeek() {
      let date = new Date();
      let w = date.getDay();
      let day = date.getDate();
      w = w === 0 ? 7 : w;
      date.setDate(day - w + 1);
      this.weekStart = dsf.date.format(date, "yyyy-mm-dd");
      date.setDate(day + 7 - w);
      this.weekEnd = dsf.date.format(date, "yyyy-mm-dd");
      this.getData()
    },
    pre() {
      let sdate = new Date(this.weekStart);
      let sday = sdate.getDate();
      sdate.setDate(sday - 7);
      this.weekStart = dsf.date.format(sdate, "yyyy-mm-dd");
       let edate = new Date(this.weekEnd);
      let eday = edate.getDate();
      edate.setDate(eday - 7);
      this.weekEnd = dsf.date.format(edate, "yyyy-mm-dd");
      this.getData();
    },
    next() {
      let sdate = new Date(this.weekStart);
      let sday = sdate.getDate();
      sdate.setDate(sday + 7);
      this.weekStart = dsf.date.format(sdate, "yyyy-mm-dd");
      let edate = new Date(this.weekEnd);
      let eday = edate.getDate();
      edate.setDate(eday + 7);
      this.weekEnd = dsf.date.format(edate, "yyyy-mm-dd");
      this.getData();
    },
    dealdata(data) {
      var timetableInfo = data.timetableInfo;
      if (!timetableInfo) {
         this.list = []
      } else {
        var list = []
        for (var key in timetableInfo) {
          var obj = {
            date: key,
            items: timetableInfo[key]
          }
          list.push(obj)
        }
        this.list = list;
      }
      
    },
    //获取数据
    getData() {
      var loading = dsf.layer.loading();
      this.$http
        .get("teas/screen/oneTimetableClass", {
          classId: this.classInfor.classId,
          begin: this.weekStart,
          end: this.weekEnd
        })
        .done((res) => {
          if (res.success && res.state == 20000) {
            this.dealdata(res.data)
          } else {
            this.$message(res.message, false);
          }
        })
        .error((err) => {
          this.$message("请求失败", false);
        })
        .always(() => {
          dsf.layer.closeLoading(loading);
        });
    },
  },
};
</script>